'use strict';

module.exports = (function () {


	/**
	 * registers a global functionhandler with callback mapped to UID.  Flash always callbacks to the global scope.
	 * @param UID String        the UID for the flash.
	 * @param eventType String  the eventType to listen for
	 * @param scope Object      scope of the callback
	 * @param method Function   callback function.
	 */
	function addExternalListener(UID, eventType, scope, method) {
		if (!window.__svtplayerCallback__) {
			window.__svtplayerCallback__ = function (UID, a_eventType, data) {
				var callback;

				if (window.__svtplayerEventListeners__[a_eventType]) {
					callback = window.__svtplayerEventListeners__[a_eventType][UID];
					if (callback !== null) {
						callback.method.apply(callback.scope, [a_eventType, data]);
					}
				}
			};
		}

		if (!window.__svtplayerEventListeners__) {
			window.__svtplayerEventListeners__ = {};
		}

		if (window.__svtplayerEventListeners__[eventType] === undefined) {
			window.__svtplayerEventListeners__[eventType] = {};
		}

		window.__svtplayerEventListeners__[eventType][UID] = {
			scope: scope,
			method: method
		};
	}

	/**
	 * remove an external listener. currently cares only about eventType
	 * and scope. might be we need more granularity in the future so we
	 * can remove listeners for particular functions, but there's no need
	 * right now as the only use for this function is when deleting a
	 * video object.
	 *
	 * @param UID String        the UID for the flash.*
	 * @param eventType String  event to listen for
	 */
	function removeExternalListener(UID, eventType) {
		if (window.__svtplayerEventListeners__ &&
			window.__svtplayerEventListeners__[eventType] &&
			window.__svtplayerEventListeners__[eventType][UID]) {
			window.__svtplayerEventListeners__[eventType][UID] = undefined;
		}
	}

	return {
		addExternalListener: addExternalListener,
		removeExternalListener: removeExternalListener
	};
}());


// WEBPACK FOOTER //
// ./src/js/util/external.js